// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

// eslint-disable-next-line @typescript-eslint/no-var-requires
const conformToMask = require("@tps/App/Libraries/react-text-mask/react-text-mask.js").conformToMask;

export type MaskPattern = (string | RegExp)[];
export type TextMask = (newValue: string, oldValue: string, options?: any) => string;
export interface TextMasks {
    phone: TextMask;
    postalCode: TextMask;
    fax: TextMask;
}

export const phonePattern: MaskPattern = [
    "(",
    /[1-9]/,
    /\d/,
    /\d/,
    ")",
    " ",
    /\d/,
    /\d/,
    /\d/,
    "-",
    /\d/,
    /\d/,
    /\d/,
    /\d/,
];

export const faxPattern: MaskPattern = [
    "(",
    /[1-9]/,
    /\d/,
    /\d/,
    ")",
    " ",
    /\d/,
    /\d/,
    /\d/,
    "-",
    /\d/,
    /\d/,
    /\d/,
    /\d/,
];

export const shortZipCodePattern: MaskPattern = [/\d/, /\d/, /\d/, /\d/, /\d/];
export const longZipCodePattern: MaskPattern = [/\d/, /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/];

function applyMask(newValue: string, oldValue: string, pattern: MaskPattern): string {
    const result = conformToMask(newValue, pattern, { guide: false });
    if (result.meta.someCharsRejected || oldValue.length < newValue.length) {
        return result.conformedValue;
    }
    return newValue;
}

const textMasks: TextMasks = {
    phone: (newValue, oldValue) => applyMask(newValue, oldValue, phonePattern),
    postalCode: (newValue, oldValue, options?: { country: string }) => {
        const country = options ? options.country : "US";
        if (country === "US") {
            return newValue.length > 5
                ? applyMask(newValue, oldValue, longZipCodePattern)
                : applyMask(newValue, oldValue, shortZipCodePattern);
        }
        return newValue;
    },
    fax: (newValue, oldValue) => applyMask(newValue, oldValue, faxPattern),
};

export default textMasks;
// we need this to be used in xPatterns
export { conformToMask };
